import { useEffect } from 'react'

import {
  cassaStore, vicinoCassaStore, cartStore, cartOpenStore,
  selectedProductStore, watchOpenStore, useStore, relockPointer,
} from '../../store/uiStore'
import { IS_TOUCH } from '../../config/touch'
import { DURATA_STAMPA } from '../main/Cassa'

// ============================================================
// La parte 2D della cassa: il richiamo quando ci si avvicina al bancone
// e l'avanzamento delle fasi. Lo scontrino vero è un oggetto 3D
// (Cassa.jsx), e da quando il pagamento è STAMPATO SUL FOGLIO qui non
// c'è più nessun pannello finale: il totale stava già sulla carta, e
// ripeterlo in un riquadro fluttuante faceva sembrare le due cose pezzi
// di interfacce diverse. Resta solo l'uscita per chi tocca lo schermo,
// che non ha un tasto ESC da premere.
//
// PERCHÉ NON SI PAGA DAL CARRELLO
// Il negozio si attraversa a piedi: pagare da un pannello ovunque ci
// si trovi svuoterebbe di senso il bancone. Il pulsante nel carrello
// ora manda in cassa, e il pagamento vero (checkout Shopify) parte da
// qui, a scontrino stampato.
// ============================================================

const ATTESA = 900          // ms in cui il POS "elabora"
const CODA = 400            // ms di pausa dopo l'ultimo centimetro di carta

export default function CassaOverlay() {
  const fase = useStore(cassaStore)
  const vicino = useStore(vicinoCassaStore)
  const cart = useStore(cartStore)
  const cartOpen = useStore(cartOpenStore)
  const selected = useStore(selectedProductStore)
  const orologio = useStore(watchOpenStore)

  // Avanzamento delle fasi. I tempi della stampa vengono da Cassa.jsx,
  // così il pannello non compare prima che la carta sia tutta fuori.
  useEffect(() => {
    if (fase === 'attesa') {
      const id = setTimeout(() => cassaStore.set('stampa'), ATTESA)
      return () => clearTimeout(id)
    }
    if (fase === 'stampa') {
      const id = setTimeout(() => cassaStore.set('fatta'), DURATA_STAMPA * 1000 + CODA)
      return () => clearTimeout(id)
    }
    return undefined
  }, [fase])

  // A scontrino pronto serve il mouse per premere "Paga"
  useEffect(() => {
    if (fase === 'fatta') document.exitPointerLock?.()
  }, [fase])

  const annulla = () => {
    cassaStore.set('ferma')
    relockPointer()
  }

  const quantita = cart?.totalQuantity || 0
  const richiamo =
    fase === 'ferma' && vicino && quantita > 0 &&
    !cartOpen && !selected && !orologio

  return (
    <>
      {richiamo && (IS_TOUCH ? (
        <button className="cassa-richiamo tappabile" onClick={() => cassaStore.set('attesa')}>
          Paga alla cassa — {quantita} {quantita === 1 ? 'articolo' : 'articoli'}
        </button>
      ) : (
        <div className="cassa-richiamo">
          Premi <kbd>E</kbd> per pagare — {quantita}{' '}
          {quantita === 1 ? 'articolo' : 'articoli'}
        </div>
      ))}

      {/* «Elaborazione…» e «Stampa dello scontrino…» NON stanno piu' qui: le
          dice la mascotte nella sua nuvoletta (Guida.jsx, che legge
          `cassaStore` da se'). Erano un pannello in basso al centro, e col
          negozio che parlava anche dall'angolo della mascotte e dagli avvisi
          della macchinetta sembravano tre interfacce diverse. */}

      {fase === 'fatta' && IS_TOUCH && (
        <button className="cassa-annulla" onClick={annulla}>
          Non ancora
        </button>
      )}
    </>
  )
}
